import TrackerForm from 'common/pages/tracker/TrackerForm.tsx'

export const TrackerFormAgency = (props) => <TrackerForm {...props} mode={props.mode} agency />
